import Masonry from 'masonry-layout';

const DEBUG = true;

export class MasonryHelper {
  public static frontend(
    el: HTMLElement,
    opt: {select: string},
  ): MasonryHelper {
    return new this(el, opt.select || '');
  }

  public static cleanup(inst: MasonryHelper): void {
    inst.destroy();
  }

  public m: Masonry = null;

  constructor(public el: HTMLElement, select = '') {
    if (select) {
      const newEl = el.querySelector(select) as HTMLElement | null;
      if (newEl !== null) this.el = newEl;
      else console.log('Unable to find target for masonry');
    }
    this.update();
  }

  public update(): void {
    this.destroy();
    this.m = new Masonry(this.el, {
      itemSelector: '.item.masonry',
    });
  }

  public destroy(): void {
    if (this.m) {
      this.m.destroy();
      this.m = null;
    }
  }

  public add(el: HTMLElement): void {
    this.m.appended([el]);
  }

  public del(el: HTMLElement): void {
    this.m.remove([el]);
  }
}
